module.exports = __webpack_public_path__ + "static/media/view-vertical-slider-icon.b815d9ca.png";